import { SignatureOutlined } from '@ant-design/icons'
import { useFormEditor } from '@contexts/FormContext'
import { CampaignEmployee } from '@models/Campaign'
import { SBAPI } from '@supplement-bacon/react-toolkit/utils'
import { useAuth } from '@utils/auth/Auth'
import {
  CAMPAIGN_EMPLOYEE_MANAGER_URL,
  CAMPAIGN_EMPLOYEE_URL,
} from '@utils/urls'
import { App, Button, Form, Modal, Space, Switch, Typography } from 'antd'
import TextArea from 'antd/es/input/TextArea'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Signature from '../Signature'

const { Text } = Typography

interface Props {
  campaignEmployee?: CampaignEmployee
  isEmployee?: boolean
}

export const SignModal = ({
  campaignEmployee: campaignEmployeeProps,
  isEmployee: isEmployeeProps,
}: Props) => {
  const {
    campaignEmployee: campaignEmployeeFormEditor,
    isEmployee: isEmployeePropsFormEditor,
  } = useFormEditor()

  const campaignEmployee = campaignEmployeeProps
    ? campaignEmployeeProps
    : campaignEmployeeFormEditor

  const isEmployee = isEmployeeProps
    ? isEmployeeProps
    : isEmployeePropsFormEditor

  if (campaignEmployee === undefined || isEmployee === undefined) return <></>

  const navigate = useNavigate()
  const { message } = App.useApp()
  const { currentUser } = useAuth()
  const [comment, setComment] = useState<string>('')
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false)
  const [checked, setChecked] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState<boolean>(false)

  const handleOk = async () => {
    setIsLoading(true)
    const baseUrl = isEmployee
      ? CAMPAIGN_EMPLOYEE_URL
      : CAMPAIGN_EMPLOYEE_MANAGER_URL

    SBAPI.Post(`${baseUrl}/${campaignEmployee.id}/sign`, {
      comment,
    })
      .then(() => {
        message.success('Entretien signé')
        navigate('/')
      })
      .catch(() =>
        message.error('Erreur lors de la signature de votre entretien')
      )
      .finally(() => setIsLoading(false))
  }

  return (
    <>
      <Button
        type="primary"
        icon={<SignatureOutlined />}
        onClick={() => setIsModalOpen(true)}
      >
        Signer
      </Button>
      <Modal
        title="Signer le document"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={() => setIsModalOpen(false)}
        okText={'Signer le document'}
        okButtonProps={{ disabled: !checked }}
        confirmLoading={isLoading}
        cancelText={'Annuler'}
      >
        <Form layout="vertical">
          <Form.Item label="Commentaire général">
            <TextArea
              rows={5}
              value={comment}
              onChange={(e) => setComment(e.target.value)}
            />
          </Form.Item>
        </Form>
        <Space
          vertical
          className="w-full"
          size={20}
          style={{ paddingBottom: 10 }}
        >
          <Space vertical className="w-full">
            <Text style={{ marginBottom: 15 }}>Signature</Text>
            <Signature
              text={`${currentUser?.firstName} ${currentUser?.lastName}`}
              opaque={checked}
            />
          </Space>
          <Space className="w-full" size={15}>
            <Switch value={checked} onChange={(e) => setChecked(e)} />
            <Text>
              En cochant cette case, je reconnais que ma signature électronique
              sera apposée sur le document et qu&apos;aucune modification ne
              pourra être effectuée par la suite.
            </Text>
          </Space>
        </Space>
      </Modal>
    </>
  )
}
